"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var componentName = 'section-title';
exports.default = {
    name: componentName,
    functional: true,
    render: function (h, ctx) {
        return h('h1', { class: ['section-title', ctx.data.staticClass] }, [
            ctx.slots().default
        ]);
    }
};
